// functional component......................
import React, { useState, useEffect } from "react";
import { Route, Routes, Link, useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import commaNumber from "comma-number";
import { formatTitle } from "../../formatTitle";
import { formatDate } from "../../formatDate";
import { useAppContext } from "../../../AppContext";
import "./style.scss";

function View1(props) {
  const { user, components, chimeraserv } = useAppContext();
  const location = useLocation();
  const params = useParams();
  const [views] = useState(["sales", "void", "deletion", "session", "audit"]);
  const [data, setData] = useState([]);
  const [currency, setCurrency] = useState({
    base: {},
    state: false,
  });
  const [load, setLoad] = useState(false);

  const headers = new Headers({
    Authorization: user.data.usrKey,
    "Content-Type": "application/json",
    Accept: "application/json",
  });

  function renderField(objData) {
    let dataValue = "";

    switch (typeof objData[1]) {
      case "string":
        dataValue = formatTitle(objData[1]);
        break;
      case "object":
        if (
          !["items", "payType", "emp", "empSig", "type"].includes(objData[0])
        ) {
          break;
        }

        dataValue = objData[1].map((obj, idx) => {
          return (
            <div key={idx}>
              {Object.entries(obj).map((object, i) => {
                let value = "";

                switch (typeof object[1]) {
                  case "string":
                    value = ` - ${formatTitle(object[1])}`;
                    break;
                  case "number":
                    switch (object[0]) {
                      case "total":
                      case "amount":
                        value = ` - ${currency?.base} ${commaNumber(
                          object[1].toFixed(2)
                        )}`;
                        break;
                      case "date":
                        value = ` - ${formatDate.long(object[1])}`;
                        break;
                      default:
                        value = ` - ${commaNumber(object[1])}`;
                        break;
                    }
                    break;
                  default:
                    break;
                }

                return <span key={i}>{value}</span>;
              })}
            </div>
          );
        });
        break;
      case "number":
        switch (objData[0]) {
          case "total":
            dataValue = `${currency?.base} ${commaNumber(
              objData[1].toFixed(2)
            )}`;
            break;
          case "date":
            dataValue = formatDate.long(objData[1]);
            break;
          default:
            if (["billNo", "delId"].includes(objData[0])) {
              dataValue = objData[1];
            } else {
              dataValue = commaNumber(objData[1]);
            }
            break;
        }
        break;
      default:
        break;
    }

    return dataValue;
  }

  function renderData() {
    const Loader = components.setting[1].component;

    const obj = data.length
      ? Object.entries(data[0]).filter(
          (d) =>
            !["_id", "status", "braKey", "chaKey", "grpKey", "__v"].includes(
              d[0]
            )
        )
      : [];

    return (
      <div className={["custForm", "custView"].join(" ")}>
        <div className={["viewTitle"]}>
          <Link
            to={
              location.state && location.state.prevUrl
                ? location.state.prevUrl
                : `/app/${params.type}`
            }
          >
            <FontAwesomeIcon
              className={["iconBack"].join(" ")}
              icon={["fas", "caret-left"]}
            />
          </Link>
          View {formatTitle(params.type)}
        </div>
        {!load ? (
          <Loader />
        ) : (
          <div className={"form"}>
            {obj.map((objData, dataKey) => (
              <div className={["form-group"]} key={dataKey}>
                <label htmlFor="exampleInputEmail1">
                  {formatTitle(objData[0])}
                </label>
                <div className={["field", "value"].join(" ")}>
                  {renderField(objData)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }

  useEffect(() => {
    async function loadData() {
      let type = params.type;

      if (type === "void") {
        type = "sales";
      }

      const [viewResponse, groupResponse] = await Promise.all([
        fetch(`${chimeraserv.urlGet}/${type}/view/0/${params.id}`, {
          headers: headers,
        }),
        fetch(`${chimeraserv.urlGet}/group`, { headers: headers }),
      ]);

      const [view, group] = await Promise.all([
        viewResponse.json(),
        groupResponse.json(),
      ]);

      const chainCurr = group[0].brands
        .filter((brandItem) => brandItem?.braKey === view[0]?.braKey)[0]
        ?.chains?.filter(
          (chainItem) => chainItem?.chaKey === view[0]?.chaKey
        )[0]?.currency;

      setData(view);
      setLoad(true);
      setCurrency({
        base: chainCurr?.toUpperCase() || group[0]?.baseCurr?.toUpperCase(),
        state: true,
      });
    }

    loadData();
    // eslint-disable-next-line
  }, []); // Only run on mount
  // Defensive check for user
  if (!user || !user.data) {
    return <div>Please log in.</div>;
  }
  return (
    <div className={"viewContainer"}>
      <div className={["viewBody"]}>
        {views.includes(params.type)
          ? renderData()
          : components.setting[0].component
          ? React.createElement(components.setting[0].component)
          : null}
      </div>
    </div>
  );
}
export default View1;
